<div class="agreement-annex-side-panel">
  <mat-tab-group mat-align-tabs="start" class="annex-tabs">
    <!-- Zakładka: Podgląd aneksu -->
    <mat-tab [label]="'Annex.ViewAnnex' | translate">
      <div class="tab-content">
        <pdf-viewer
          [src]="pdfSrc"
          [show-all]="true"
          [render-text]="true"
          [original-size]="true"
          [fit-to-page]="true"
          [autoresize]="true"
          [show-borders]="true"
          class="pdf-viewer"
        ></pdf-viewer>
      </div>
    </mat-tab>

    <!-- Zakładka: Szczegóły umowy -->
    <mat-tab [label]="'WorkerAgreementDetails' | translate">
      <div class="tab-content">
        <app-agreement-details-tab [agreement]="agreement"> </app-agreement-details-tab>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
